export enum SuccessStatus {
  LOGIN = 'login',
  SIGNUP_EMPLOYER = 'signup_employer',
  SIGNUP_FREELANCER = 'signup_freelancer',
}

export interface LoginSignupUserStatus {
  userId: number;
  successStatus: SuccessStatus;
}
